import React from 'react'
import { css } from '@emotion/core'
import { useWindowSize } from 'react-use'
import { useTranslation } from 'react-i18next'
import { DiscountSettingType } from '@/models/sales'
import { AccountsReceivable } from '@/models/accounts-receivable'

type Props = {
  discountSettings: DiscountSettingType[]
}

export const SettingDiscountList: React.FC<Props> = ({ discountSettings }) => {
  const windows = useWindowSize()
  const { t } = useTranslation()
  return (
    <>
      <div css={[paymentListHeaderStyle, scrollStyle]}>
        <div css={displayOrderWidthStyle}>{t('Display order')}</div>
        <div css={subjectCodeWidthStyle}>{t('Discount item ID')}</div>
        <div css={nameWidthStyle}>{t('Discount item')}</div>
        <div css={priceWidthStyle}>{t('Amount of money')}</div>
        <div css={isAccountsReceivableWidthStyle}>{t('Outstanding sales')}</div>
        <div css={accountsReceivableNameWidthStyle}>{t('Accounts receivable')}</div>
        <div css={discountTypeWidthStyle}>{t('Discount Type')}</div>
      </div>
      <ul
        css={[paymentListStyle, scrollStyle]}
        style={{
          height: windows.height - 270,
        }}
      >
        {discountSettings.map((discountSetting, index) => (
          <li key={index}>
            <div css={displayOrderWidthStyle}>{discountSetting.displayOrder}</div>
            <div css={subjectCodeWidthStyle}>{discountSetting.discountSubjectCode ? discountSetting.discountSubjectCode : '-'}</div>
            <div css={nameWidthStyle}>{discountSetting.name}</div>
            <div css={priceWidthStyle}>
              {discountSetting.name === 'ポイント' ? '-' : `¥${Number(discountSetting.price).toLocaleString()}`}
            </div>
            <div css={isAccountsReceivableWidthStyle}>
              {discountSetting.isAccountsReceivable === AccountsReceivable.AccountsReceivable ? t('Outstanding sales') : '-'}
            </div>
            <div css={accountsReceivableNameWidthStyle}>
              {discountSetting.accountsReceivableName ? discountSetting.accountsReceivableName : '-'}
            </div>
            <div css={discountTypeWidthStyle}>{discountSetting.isPaymentAllocation ? t('Payment Allocation') : t('Markdown')}</div>
          </li>
        ))}
      </ul>
    </>
  )
}

const displayOrderWidthStyle = css({ minWidth: 60, maxWidth: 60 })
const subjectCodeWidthStyle = css({ minWidth: '15%', maxWidth: '15%' })
const nameWidthStyle = css({ minWidth: '35%', maxWidth: '35%' })
const priceWidthStyle = css({ minWidth: '10%', maxWidth: '10%' })
const isAccountsReceivableWidthStyle = css({ minWidth: '10%', maxWidth: '10%' })
const accountsReceivableNameWidthStyle = css({ flexGrow: 1 })
const discountTypeWidthStyle = css({ minWidth: 96, maxWidth: 96 })

const paymentListHeaderStyle = css({
  background: '#F5F5F5',
  color: '#676767',
  display: 'flex',
  fontSize: 12,
  fontWeight: 'bold',
  padding: '10px 32px',
})

const paymentListStyle = css({
  li: {
    display: 'flex',
    padding: '16px 32px',
    color: '#272727',
    fontSize: 14,
    borderBottom: '1px #F2F2F2 solid',
  },
})

const scrollStyle = css({ overflowY: 'scroll' })
